import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0026',
    ecrans: ['00-2']
});
